var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.12 13.2432C25.12 12.178 25.0345 11.4007 24.8494 10.5946H12.8169V15.4024H19.8797C19.7374 16.5972 18.9684 18.3966 17.2596 19.6057L17.2357 19.7666L21.0401 22.746L21.3037 22.7726C23.7244 20.5126 25.12 17.1874 25.12 13.2432Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8169 25.9107C16.2771 25.9107 19.1819 24.7591 21.3037 22.7726L17.2596 19.6057C16.1774 20.3686 14.725 20.9012 12.8169 20.9012C9.42787 20.9012 6.55148 18.6413 5.52612 15.5176L5.37583 15.5305L1.4199 18.6254L1.36816 18.7708C3.47561 23.0029 7.80448 25.9107 12.8169 25.9107Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5264 15.5176C5.25585 14.7115 5.09927 13.8478 5.09927 12.9553C5.09927 12.0628 5.25585 11.1992 5.51216 10.3931L5.505 10.2214L1.49949 7.07677L1.36844 7.13978C0.499858 8.89597 0.00146484 10.8681 0.00146484 12.9553C0.00146484 15.0426 0.499858 17.0146 1.36844 18.7708L5.5264 15.5176Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8169 5.00937C15.2234 5.00937 16.8466 6.06018 17.7723 6.93833L21.3891 3.36839C19.1678 1.28115 16.2771 0 12.8169 0C7.80448 0 3.47561 2.90773 1.36816 7.13978L5.51189 10.3931C6.55148 7.26938 9.42787 5.00937 12.8169 5.00937Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.1333,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.04c4589d95c9b6c095c8857dff3f2630.svg";
export { ForwardRef as ReactComponent };